import { Component, OnDestroy, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForumModalComponent } from '../forum-modal/forum-modal.component';
import { TribesService } from 'src/app/services/tribes.service';
import { TableTribesComponent } from 'src/app/components/table-tribes/table-tribes.component';
import { RowComponent } from 'src/app/components/table-tribes/row/row.component';
import {
  AttributesItribes,
  ITribesResponse,
} from 'src/app/shared/interfaces/tribe.interface';
import { ModalSideComponent } from 'src/app/components/modal-side/modal-side.component';
import { ModalTribeServiceService } from 'src/app/services/modal-tribe-service.service';
import { Subscription } from 'rxjs';
import { IUserProfileComplete } from 'src/app/shared/interfaces/profile.interface';
import { ICommentTribe, ICommentTribeNested } from 'src/app/shared/interfaces/comment-tribe.interface';
import { InputCommentTribeComponent } from 'src/app/components/input-comment-tribe/input-comment-tribe.component';
import { CardCommentTribeComponent } from 'src/app/components/cards/card-comment-tribe/card-comment-tribe.component';
import { CardCommentTribeResponseComponent } from 'src/app/components/cards/card-comment-tribe-response/card-comment-tribe-response.component';
import { UserProfileService } from 'src/app/services/user-profile.service';
import { CommentsTribeService } from 'src/app/services/comments-tribe.service';
import { getNestTribeComments } from 'src/app/shared/utils/commentsTribes.util';
import { id } from 'date-fns/locale';
import { removeDuplicates } from 'src/app/shared/utils/general.ultil';
import { ModalSideDialogComponent } from 'src/app/components/modal-side-dialog/modal-side-dialog.component';

@Component({
  selector: 'app-tribes',
  standalone: true,
  templateUrl: './tribes.component.html',
  styleUrls: ['./tribes.component.scss'],
  imports: [
    CommonModule,
    ForumModalComponent,
    TableTribesComponent,
    RowComponent,
    ModalSideComponent,
    InputCommentTribeComponent,
    CardCommentTribeComponent,
    CardCommentTribeResponseComponent,
    ModalSideDialogComponent,
  ],
})
export class TribesComponent implements OnDestroy {
  option: string = 'Todas las tribus';
  isModalOpen: boolean = false;
  tribesList: ITribesResponse[] = [];
  isActiveModal: boolean=false;
  loading: boolean = true;
  userImgLogued: string | null= null;
  // @ViewChild('modalSide', { static: true }) modalSlide:
  //   | ModalSideComponent
  //   | undefined;

  lastInteraction: string = '- /- / -';
  courseTitle: string = '---';
  getResultCommentCreated = Subscription.EMPTY;
  OriginalComments: ICommentTribe[] = [];
  dataModal: {
    ownerProfile: IUserProfileComplete | null;
    comments: ICommentTribeNested[];
    attributes: AttributesItribes;
  } = {} as {
    ownerProfile: IUserProfileComplete;
    comments: ICommentTribeNested[];
    attributes: AttributesItribes;
  };
  tribeSelected = {} as ITribesResponse;
  constructor(
    private tribesService: TribesService,
    // protected modalTribeService: ModalTribeServiceService,
    private userProfileService:UserProfileService,
    private commetTribeService :CommentsTribeService
  ) {
    this.getResultCommentCreated = this.commetTribeService.getResultCommentCreated$.subscribe((data) => {

      // console.log("OBERVARDOR:::: recibe data created in MAIN TRIBE");
      // console.log("::::::::::::: data",data);
      const element = data;
      const dataForNested:ICommentTribe = {
        id_tribe: element.relationships.entity_id.data.id,
        uuid_tribe: element.relationships.entity_id.data.id,
        target_uuid: element.relationships.entity_id.data.id,
        // id_comment: element.id,
        // field_name:element.attributes.field_name,
        status: element.attributes.status,
        subject: element.attributes.subject,
        user_uid: element.relationships.uid.data!.id,
        // entity_id:element.attributes.entity_id[0].target_id,
        created: element.attributes.created,
        changed: element.attributes.changed,
        thread: element.attributes.thread,
        thread_array: element.attributes.thread
          .replaceAll('/', '')
          .split('.'),
        comment_body_value: element.attributes.comment_body.value,
        id_comment:element.id,

      };

      this.OriginalComments.push(dataForNested);

      this.dataModal.comments = getNestTribeComments([...this.OriginalComments]).reverse();
    });
  }
  ngOnDestroy(): void {
    // console.log("destroy row component")
    if (this.getResultCommentCreated) {
      this.getResultCommentCreated.unsubscribe();
    }
    this.isActiveModal = false;
    // this.modalTribeService.close();
    // document.getElementById('modal-tribe')?.remove();
  }
  ngOnInit(): void {
    this.tribesService.getTribesForAllCoursesEnrolled().subscribe((c: any) => {
      // console.log('getTribesForAllCoursesEnrolled', c);
      const forosListTribes:ITribesResponse[] = c.flat(1);
      this.tribesList = removeDuplicates(forosListTribes,'id');

    });
    this.userImgLogued = localStorage.getItem('userImg');
  }

  onClick(opt: any) {}

  onClickOpenModal(opt: string) {
    this.isModalOpen = true;
  }
  commentCreatedEvent(event: any) {
    // console.log('commentCreatedEvent tribes page', event);
  }

  async getNewInputComment(subject:string){
    /// this function is for commenting in root of the forum tribe
    const commentInRootTribe = null;
    this.commetTribeService.createCommentTribe(this.tribeSelected.id,subject,commentInRootTribe).subscribe(({data}:any) => {
      const element = data;
      const dataForNested:ICommentTribe = {
        id_tribe: element.relationships.entity_id.data.id,
        uuid_tribe: element.relationships.entity_id.data.id,
        target_uuid: element.relationships.entity_id.data.id,
        id_comment: element.id,
        // field_name:element.attributes.field_name,
        status: element.attributes.status,
        subject: element.attributes.subject,
        user_uid: element.relationships.uid.data.id,
        // entity_id:element.attributes.entity_id[0].target_id,
        created: element.attributes.created,
        changed: element.attributes.changed,
        thread: element.attributes.thread,
        thread_array: element.attributes.thread
          .replaceAll('/', '')
          .split('.'),
        comment_body_value: element.attributes.comment_body.value,
      };
      this.OriginalComments.push(dataForNested);
      this.dataModal.comments = getNestTribeComments([...this.OriginalComments]).reverse();
      // console.log("llego a row el comment y se envio al observer",subject);
      // this.commentCreatedEvent.emit(this.tribe); //doesnt do anything
    });

  }
  onClickRow(event: { tribeSelected: ITribesResponse }) {
    this.tribeSelected = event.tribeSelected;
    this.loading = true;
    const {  tribeSelected } = event;
    // this.modalTribeService.open('modal-tribe');
    this.fetchComments(tribeSelected);
    this.openModal();
    // this.loading = false;

  }

  fetchComments(tribeSelected: ITribesResponse) {
    const idProfile = tribeSelected.relationships.revision_uid.data.id;
    const tribeId = tribeSelected.attributes.drupal_internal__nid;
    const attributes = tribeSelected.attributes;
    // console.log('onClickRow tribes idProf:',idProfile," idTrib:"+tribeId);
    this.userProfileService
      .getUserProfileCompleteById(idProfile)
      .subscribe((dataProfile: IUserProfileComplete) => {
        // console.log('data raw ownerProfile-------------->', dataProfile);
        this.dataModal.ownerProfile = dataProfile;
        // console.log('data modal ownerProfile:', this.dataModal.ownerProfile);

      });
      this.commetTribeService
      .getCommentsByIdTribe(tribeId)
      .subscribe((data) => {
        this.OriginalComments = data;
        this.dataModal.comments = data.length>0 ? getNestTribeComments(data).reverse():[];
        // console.log('data modal comments:', this.dataModal.comments);
        this.dataModal.attributes = attributes;
        this.loading = false;
      });
  }



  openModal() {
    this.isActiveModal = true;
  }

  closeModal() {
    this.isActiveModal = false;
  }
}
